import React from 'react';
import { Button, CREATE, useDataProvider, useNotify, TopToolbar } from 'react-admin';
import IconDoneIcon from '@material-ui/icons/Done';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import TimeIcon from '@material-ui/icons/AccessTime';
import DisputeWonIcon from '@material-ui/icons/AssignmentTurnedIn';
import DisputeLostIcon from '@material-ui/icons/AssignmentLate';

const PaymentFailureShowActions = props => {
	const dataProvider = useDataProvider();
	const notify = useNotify();

	const { data } = props;

	const handleAction = method => {
		dataProvider(CREATE, 'paymentFailures', { id: data.id, method: method })
			.then(() => {
				notify('resources.payments.notifications.successfullySettled', 'info');
			})
			.catch(error => {
				notify(error.message, 'error');
			});
	};

	const confirm = () => {
		handleAction('confirm');
	};

	const startDisputeProcess = () => {
		handleAction('startDisputeProcess');
	};

	const expirePaymentFailure = () => {
		handleAction('expire');
	};

	const disputeWon = () => {
		handleAction('disputeProcessWon');
	};

	const disputeLost = () => {
		handleAction('disputeProcessLost');
	};

	return (
		<TopToolbar>
			{data && (
				<Button
					label="resources.paymentFailures.actions.confirm"
					component="button"
					color="primary"
					onClick={confirm}
					disabled={data.paymentFailureStatus !== 'Created'}
				>
					<IconDoneIcon />
				</Button>
			)}
			{data && (
				<Button
					label="resources.paymentFailures.actions.startDisputeProcess"
					component="button"
					color="primary"
					onClick={startDisputeProcess}
					disabled={data.paymentFailureStatus !== 'Pending'}
				>
					<FlashOnIcon />
				</Button>
			)}
			{data && (
				<Button
					label="resources.paymentFailures.actions.expirePaymentFailure"
					component="button"
					color="primary"
					onClick={expirePaymentFailure}
					disabled={data.paymentFailureStatus !== 'Pending'}
				>
					<TimeIcon />
				</Button>
			)}

			{data && (
				<Button
					label="resources.paymentFailures.actions.disputeWon"
					component="button"
					color="primary"
					onClick={disputeWon}
					disabled={data.paymentFailureStatus !== 'DisputeInProgress'}
				>
					<DisputeWonIcon />
				</Button>
			)}
			{data && (
				<Button
					label="resources.paymentFailures.actions.disputeLost"
					component="button"
					color="primary"
					onClick={disputeLost}
					disabled={data.paymentFailureStatus !== 'DisputeInProgress'}
				>
					<DisputeLostIcon />
				</Button>
			)}
		</TopToolbar>
	);
};

export default PaymentFailureShowActions;
